import API_DOMAIN from './apiDomain';
import EdsApiClient from './client';

const api = new EdsApiClient(API_DOMAIN || '');

export default api;
